import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { AnimatePresence, motion } from "framer-motion";

import image_a from "../../../assets/imgs/user/A_Dorsiflexión-de-tobillo.jpg";
import image_b from "../../../assets/imgs/user/B_Evaluación-sentadilla-monopodal.jpg";
import image_c_2 from "../../../assets/imgs/user/C_2_evaluacion_de_la_postura_estatica_2_Sindrome-Cruzado.jpg";
import image_c from "../../../assets/imgs/user/C1_Evaluación-de-postura_estática.jpg";
//
import image_d from "../../../assets/imgs/user/D_Evaluaciòn-Sentadilla_brazos_por_encima_de_la_cabeza.jpg";
import image_e from "../../../assets/imgs/user/E_Test-Movilidad-Cadera.jpg";
//
import image_f from "../../../assets/imgs/user/F_Fuerza-miembros-superiores.jpg";
import image_g from "../../../assets/imgs/user/G_Test-Fuerza-Sentadillas.jpg";
import image_h from "../../../assets/imgs/user/H_Test_Cardio-Respiratorio.jpg";
import {
  useValorationStateEalthQuery,
  useValorationStateEalthHistoryQuery,
  useStoreValorationStateEalthMutation,
} from "@/app/valorations/valoration.api";
import ValorationStateEalthHistory from "./ValorationStateEalthHistory";
import i18n from "@/app/i18n";

const ValorationStateEalth = () => {
  const { id } = useParams<{ id: string }>();
  const [modalContent, setModalContent] = useState<{
    title: string;
    sections: any[];
  } | null>(null);

  const [showHistory, setShowHistory] = useState(false);

  const [tableId, setTableId] = useState<string | null>(null);
  const [initiaLoader, setInitialLoader] = useState(false);

  const [storeValorationStateEalth, { originalArgs }] =
    useStoreValorationStateEalthMutation();

  const { data: historyData, isLoading: isLoadingHistory } =
    useValorationStateEalthHistoryQuery({ id, table: tableId });

  const { data, isLoading } = useValorationStateEalthQuery({ id });

  const getTable = ({ id }) => {
    switch (id) {
      case "ankleDorsiflexion":
        setTableId("ankle_dorsiflexion_wall_test");
        return "ankle_dorsiflexion_wall_test";
      case "singleLegSquat":
        setTableId("single_leg_squat_assessment");
        return "single_leg_squat_assessment";
      case "staticPosture":
        setTableId("static_posture_assessment");
        return "static_posture_assessment";
      case "overheadSquat":
        setTableId("overhead_squat_assessment");
        return "overhead_squat_assessment";
      case "hipMobility":
        setTableId("hip_mobility_stick_test");
        return "hip_mobility_stick_test";
      case "upperBodyStrength":
        setTableId("upper_body_strength_pushups");
        return "upper_body_strength_pushups";
      case "lowerBodyStrength":
        setTableId("lower_body_strength_squat_test");
        return "lower_body_strength_squat_test";
      case "cardio":
        setTableId("cardio_step_test");
        return "cardio_step_test";
      default:
        setTableId(null);
        return null;
    }
  };
  /* 
  const normalizeData = (data: any) => {
    const valueMap = {
      Good: "Bueno",
      Fair: "Regular",
      Unable: "Incapaz",
      Excellent: "Excelente",
      Average: "Promedio",
      Poor: "Deficiente", // Adjust based on actual data
      "Very Low": "Muy bajo",
      Normal: "Normal",
      Limited: "Limitada",
      "Severely reduced": "Severamente reducida",
    };

    const mapValues = (obj) => {
      const newObj = {};
      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          newObj[key] = mapValues(obj[key]); // Recurse for nested objects
        } else if (valueMap[obj[key]]) {
          newObj[key] = valueMap[obj[key]]; // Map English to Spanish
        } else {
          newObj[key] = obj[key]; // Keep unchanged
        }
      }
      return newObj;
    };

    return mapValues(data);
  };
 */

  const normalizeData = (data: any) => {
    // Definir mapeos para cada idioma
    const valueMaps = {
      es: {
        Good: "Bueno",
        Fair: "Regular",
        Unable: "Incapaz",
        Excellent: "Excelente",
        Average: "Promedio",
        Deficient: "Deficiente", // Usamos "Deficiente" en lugar de "Poor" para consistencia
        "Very Low": "Muy bajo",
        Normal: "Normal",
        Limited: "Limitada",
        "Severely reduced": "Severamente reducida",
      },
      en: {
        Good: "Good",
        Fair: "Fair",
        Unable: "Unable",
        Excellent: "Excellent",
        Average: "Average",
        Deficient: "Deficient",
        "Very Low": "Very Low",
        Normal: "Normal",
        Limited: "Limited",
        "Severely reduced": "Severely reduced",
      },
      pt: {
        Good: "Bom",
        Fair: "Regular",
        Unable: "Incapaz",
        Excellent: "Excelente",
        Average: "Médio",
        Deficient: "Deficiente",
        "Very Low": "Muito baixo",
        Normal: "Normal",
        Limited: "Limitada",
        "Severely reduced": "Severamente reduzida",
      },
    };

    // Seleccionar el mapeo según el idioma actual
    const valueMap =
      valueMaps[i18n.language as keyof typeof valueMaps] || valueMaps.es; // Fallback a español

    const mapValues = (obj) => {
      const newObj = {};
      for (const key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          newObj[key] = mapValues(obj[key]);
        } else if (valueMap[obj[key]]) {
          newObj[key] = valueMap[obj[key]]; 
        } else {
          newObj[key] = obj[key]; 
        }
      }
      return newObj;
    };

    return mapValues(data);
  };

  const formik = useFormik({
    initialValues: {
      emergencyContact: "",
      restingHeartRate: "",
      ankleDorsiflexion: "",
      ankleDorsiflexionObservations: "",
      singleLegSquat: "",
      singleLegSquatFields: {
        kneeAlignment: "",
        pelvicStability: "",
        ankleMobility: "",
        squatDepth: "",
        posturalControl: "",
      },
      staticPosture: "",
      staticPostureFields: {
        sagittal: {
          bodyAxis: "",
          spinalCurvature: "",
          headPosition: "",
          pelvicTilt: "",
          kneeFlexion: "",
        },
        frontal: {
          shoulderSymmetry: "",
          spinalAlignment: "",
          pelvicLevel: "",
          kneeValgusVarus: "",
          footArch: "",
        },
        transversal: {
          headRotation: "",
          scapularRotation: "",
          pelvicTorsion: "",
          kneeFootOrientation: "",
        },
      },
      overheadSquat: "",
      overheadSquatFields: {
        sagittal: {
          trunkControl: "",
          ankleMobility: "",
          hipMobility: "",
          spinalMobility: "",
        },
        frontal: {
          kneeAlignment: "",
          footAlignment: "",
        },
        transversal: {
          compensatoryRotations: "",
        },
      },
      hipMobility: "",
      hipMobilityFields: {
        controlMotor: "",
        hipHingePattern: "",
        stabilityMobility: "",
      },
      upperBodyStrength: "",
      upperBodyStrengthObservations: "",
      lowerBodyStrength: "",
      lowerBodyStrengthObservations: "",
      cardio: "",
      cardioObservations: "",
    },
    onSubmit: async (values) => {
      console.log("Form submitted:", values);
    },
  });

  const isInitializing = useRef(true);
  const lastSavedValues = useRef(null);

  useEffect(() => {
    if (data) {
      formik.setValues(normalizeData(data) as any);
      isInitializing.current = false;
    }
  }, [id, data]);

  useEffect(() => {
    if (!isInitializing.current) {
      const currentValues = formik.values;
      if (
        JSON.stringify(currentValues) !==
        JSON.stringify(lastSavedValues.current)
      ) {
        storeValorationStateEalth({
          body: {
            userId: id,
            ...currentValues,
          },
        });
        lastSavedValues.current = currentValues;
      }
    }
  }, [formik.values]);

  /*   const questions = [
    {
      id: "ankleDorsiflexion",
      text: "Dorsiflexión de tobillo contra la pared",
      image: image_a,
      options: ["Normal", "Limitada", "Severamente reducida"],
      hasObservations: true,
      modalContent: {
        title: "Dorsiflexión de tobillo contra la pared",
        sections: [
          {
            heading: "¿En qué consiste el test?",
            subsections: [
              {
                heading: "Posición inicial",
                text: "El cliente se coloca frente a una pared posición de lunge unilateral. El pie evaluado debe flexionarse, manteniendo el arco plantar y el talón pegado al suelo.",
              },
              {
                heading: "Ejecución",
                text: "Se pide al cliente que avance la rodilla hacia la pared sin despegar el talón del suelo. Se mide la distancia desde la punta del pie y la pared cuando la rodilla toca la pared sin levantar el talón.",
              },
            ],
          },
          {
            heading: "Evaluación de resultados",
            text: "Si el talón se despega antes de que la rodilla toque la pared, significa que hay una restricción en la dorsiflexión, posiblemente causada por acortamiento del sóleo o rigidez de la articulación del tobillo.",
          },
          {
            heading: "Rangos de dorsiflexión",
            table: [
              [
                "Normal",
                "10-12 cm de distancia entre el dedo gordo y la pared",
              ],
              ["Limitada", "Menos de 10 cm"],
              ["Severamente reducida", "Menos de 5 cm"],
            ],
          },
          {
            heading: "Protocolo recomendado para mejorarlo",
            text: "Liberación con foamroller o pelota\nTrabajos de movilidad dinámica de la zona\nElevaciones de talón excéntricas\nCaminata en talones con las puntas levantadas",
          },
        ],
      },
    },
    {
      id: "singleLegSquat",
      text: "Evaluación de la Sentadilla a Una Sola Pierna",
      image: image_b,
      options: ["Bueno", "Regular", "Incapaz"],
      fieldGroups: [
        {
          label: "Criterios",
          key: "",
          fields: [
            { name: "kneeAlignment", label: "Alineación de rodilla" },
            { name: "pelvicStability", label: "Estabilidad pélvica" },
            { name: "ankleMobility", label: "Movilidad de tobillo" },
            { name: "squatDepth", label: "Profundidad de la sentadilla" },
            { name: "posturalControl", label: "Control postural" },
          ],
          options: ["Bueno", "Regular", "Incapaz"],
        },
      ],
      modalContent: {
        title: "Evaluación de la Sentadilla a Una Sola Pierna",
        sections: [
          {
            heading: "¿En qué consiste?",
            text: "Es un test funcional que evalúa la estabilidad, fuerza y control motor de cada pierna, además de detectar deficiencias en la movilidad del tobillo, rodilla y cadera.",
          },
          {
            heading: "Procedimiento",
            subsections: [
              {
                heading: "Posición inicial",
                text: "De pie, con los brazos al frente. Se levanta una pierna sin tocar el suelo y se mantiene la pierna de apoyo alineada.",
              },
              {
                heading: "Ejecución",
                text: "Se flexiona la rodilla y la cadera para descender en una sentadilla, bajando lo más posible sin perder control. El talón de apoyo permanece en contacto con el suelo. Se regresa a la posición inicial de forma controlada.",
              },
            ],
          },
          {
            heading: "Evaluación",
            text: "Se analiza la alineación de la rodilla (evitar valgo), estabilidad de la pelvis y movilidad del tobillo. También se observa la profundidad de la sentadilla y el control postural.",
          },
          {
            heading: "Criterios de Evaluación",
            text: "Cada criterio se califica como Bueno (B), Regular (R), Incapaz (I)",
            table: [
              ["Criterio", "Bueno (B)", "Regular (R)", "Incapaz (I)"],
              [
                "Alineación de rodilla",
                "Se mantiene alineada, sin desviaciones",
                "Leve valgo de rodilla al descender",
                "Valgo pronunciado desde el inicio",
              ],
              [
                "Estabilidad pélvica",
                "Control total, pelvis estable",
                "Ligera inestabilidad",
                "Pérdida total de estabilidad",
              ],
              [
                "Movilidad de tobillo",
                "Suficiente rango de movimiento",
                "Restricción leve",
                "Movilidad muy limitada, el talón se levanta",
              ],
              [
                "Profundidad de la sentadilla",
                "Baja con control total",
                "Baja con dificultad",
                "No logra profundidad o pierde el equilibrio",
              ],
              [
                "Control postural",
                "Movimiento fluido, sin compensaciones",
                "Inclinación leve del tronco",
                "Inclinación excesiva o caída",
              ],
            ],
          },
          {
            heading:
              "Recomendaciones según los resultados para trabajar con el cliente",
            text: "Déficit de estabilidad: Trabajar ejercicios de fortalecimiento del core y control neuromuscular.\nFalta de movilidad en tobillo: Implementar estiramientos y movilidad articular.\nDebilidad en miembros inferiores: Incluir ejercicios de fuerza excéntrica y unilateral en el entrenamiento\nMala alineación de rodilla: Corregir con ejercicios de trabajo de glúteo sobre todo glúteo medio,\nNota: progresar siempre de ejercicios analíticos a ejercicio con más demanda de control motor.",
          },
        ],
      },
    },
    {
      id: "staticPosture",
      text: "Test evaluación de la postura estática",
      image: image_c,
      image_2: image_c_2,
      options: ["Bueno", "Regular", "Incapaz"],
      fieldGroups: [
        {
          label: "Plano Sagital (Vista Lateral)",
          key: "sagittal",
          fields: [
            { name: "bodyAxis", label: "Alineación del eje corporal" },
            { name: "spinalCurvature", label: "Curvaturas de la columna" },
            { name: "headPosition", label: "Posición de la cabeza" },
            { name: "pelvicTilt", label: "Inclinación pélvica" },
            { name: "kneeFlexion", label: "Extensión o flexión de rodillas" },
          ],
          options: ["Bueno", "Regular", "Incapaz"],
        },
        {
          label: "Plano Frontal (Vista Anterior y Posterior)",
          key: "frontal",
          fields: [
            {
              name: "shoulderSymmetry",
              label: "Simetría de hombros y escápulas",
            },
            { name: "spinalAlignment", label: "Alineación de la columna" },
            { name: "pelvicLevel", label: "Nivelación de la pelvis" },
            { name: "kneeValgusVarus", label: "Valgo o varo de rodillas" },
            { name: "footArch", label: "Soporte del arco plantar" },
          ],
          options: ["Bueno", "Regular", "Incapaz"],
        },
        {
          label: "Plano Transversal (Vista Superior e Inferior)",
          key: "transversal",
          fields: [
            { name: "headRotation", label: "Rotación de la cabeza" },
            {
              name: "scapularRotation",
              label: "Rotación escapular y torácica",
            },
            { name: "pelvicTorsion", label: "Torsión pélvica" },
            {
              name: "kneeFootOrientation",
              label: "Orientación de rodillas y pies",
            },
          ],
          options: ["Bueno", "Regular", "Incapaz"],
        },
      ],
      modalContent: {
        title: "Test evaluación de la postura estática",
        sections: [
          {
            heading: "Descripción",
            text: "El Test es un análisis detallado de la alineación corporal en los planos sagital, frontal y transversal, con el objetivo de identificar desequilibrios musculoesqueléticos y compensaciones posturales. Se realiza mediante observación visual, permitiendo detectar desajustes posturales que puedan afectar la AVD O AVD y así aumentar el riesgo de lesiones o patologías.",
          },
          {
            heading: "Síndromes Asociados",
            subsections: [
              {
                heading: "Síndrome Cruzado Superior",
                text: "Desequilibrio muscular en la parte superior del cuerpo con:\nMúsculos inhibidos (débiles): Flexores profundos del cuello, romboides y trapecio medio/inferior.\nMúsculos hiperactivos (tensos): Pectorales mayor/menor, elevador de la escápula y trapecio superior.",
              },
              {
                heading: "Síndrome Cruzado Inferior",
                text: "Desequilibrio en la región lumbopélvica que afecta la estabilidad postural con:\nMúsculos inhibidos (débiles): Abdominales y glúteos mayores/medio.\nMúsculos hiperactivos (tensos): Psoas, recto femoral, abductores y erectores lumbares.",
              },
            ],
          },
        ],
      },
    },
    {
      id: "overheadSquat",
      text: "Evaluación de Sentadilla con Brazos por Encima de la Cabeza",
      image: image_d,
      options: ["Bueno", "Regular", "Incapaz"],
      fieldGroups: [
        {
          label: "Plano Sagital",
          key: "sagittal",
          fields: [
            { name: "trunkControl", label: "Control del Tronco" },
            { name: "ankleMobility", label: "Movilidad de Tobillos" },
            { name: "hipMobility", label: "Movilidad de Caderas" },
            { name: "spinalMobility", label: "Movilidad de la Columna" },
          ],
          options: ["Bueno", "Regular", "Incapaz"],
        },
        {
          label: "Vista Frontal",
          key: "frontal",
          fields: [
            { name: "kneeAlignment", label: "Alineación de Rodillas" },
            { name: "footAlignment", label: "Alineación de Pies" },
          ],
          options: ["Bueno", "Regular", "Incapaz"],
        },
        {
          label: "Plano Transversal",
          key: "transversal",
          fields: [
            {
              name: "compensatoryRotations",
              label: "Rotaciones Compensatorias",
            },
          ],
          options: ["Bueno", "Regular", "Incapaz"],
        },
      ],
      modalContent: {
        title: "Evaluación de Sentadilla con Brazos por Encima de la Cabeza",
        sections: [
          {
            heading: "Descripción",
            text: "Es un test funcional que analiza la movilidad, estabilidad y patrones de movimiento del cuerpo en una acción fundamental como la sentadilla profunda.\nObjetivo: Identificar restricciones de movilidad, desequilibrios musculares y disfunciones en la mecánica del movimiento.",
          },
          {
            heading: "Aspectos Evaluados",
            text: "Plano sagital: Control del tronco, movilidad de tobillos, caderas y columna.\nVista frontal: Alineación de rodillas y pies.\nPlano transversal: Rotaciones compensatorias.",
          },
          {
            heading: "Posibles disfunciones detectadas",
            text: "Colapso de rodillas (valgo dinámico).\nRestricción en dorsiflexión de tobillo.\nInclinación o hiperextensión del tronco.\nDéficit en la activación de glúteos y core.",
          },
        ],
      },
    },
    {
      id: "hipMobility",
      text: "Test de movilidad de cadera con palo",
      image: image_e,
      options: ["Bueno", "Regular", "Deficiente"],
      fieldGroups: [
        {
          label: "Criterios",
          key: "",
          fields: [
            {
              name: "controlMotor",
              label: "Mantiene contacto con los 3 puntos del palo",
            },
            {
              name: "hipHingePattern",
              label: "Movimiento eficiente sin flexión lumbar",
            },
            {
              name: "stabilityMobility",
              label: "Coordinación entre cadera y tronco",
            },
          ],
          options: ["Bueno", "Regular", "Deficiente"],
        },
      ],
      modalContent: {
        title: "Test de movilidad de cadera con palo",
        sections: [
          {
            heading: "Descripción",
            text: "Este test evalúa la capacidad de disociar el movimiento de la cadera sin compensaciones en la columna lumbar. Se ejecuta con un palo en la espalda tocando tres puntos clave:\nCabeza\nParte media de la espalda\nSacro",
          },
          {
            heading: "Lo que se valora",
            text: "Control motor: Capacidad de mantener las tres zonas de contacto.\nPatrón de bisagra de cadera: Movimiento eficiente sin flexión lumbar.\nEstabilidad y movilidad: Coordinación entre cadera y tronco.",
          },
          {
            heading: "Recomendaciones según la ciencia",
            text: "Nota: Mantener la lordosis natural sin perder contacto del palo. Evitar flexión lumbar compensatoria. Promover ejercicios correctivos si hay deficiencias.",
          },
        ],
      },
    },
    {
      id: "upperBodyStrength",
      text: "Test de fuerza en miembros superiores (FLEXIONES)",
      image: image_f,
      options: ["Excelente", "Bueno", "Promedio", "Deficiente", "Muy bajo"],
      hasObservations: true,
      modalContent: {
        title: "Test de fuerza en miembros superiores (FLEXIONES)",
        sections: [
          {
            heading: "Descripción",
            text: "Es un test funcional que analiza la fuerza, estabilidad y control neuromuscular del tren superior, centrándose en el rendimiento de los músculos pectorales, deltoides, tríceps y core.",
          },
          {
            heading: "Objetivo",
            text: "Evaluar la resistencia muscular, alineación postural y compensaciones biomecánicas durante el movimiento, permitiendo identificar deficiencias en fuerza, estabilidad escapular y activación del core.",
          },
          {
            heading: "Aspectos Evaluados",
            text: "Control escapular: Evaluación de retracción y depresión adecuada.\nAlineación corporal: Observación de la estabilidad del tronco y caderas.\nPatrón de movimiento: Simetría y profundidad del descenso.\nCompensaciones: Colapso de escápulas, hiperextensión lumbar o rotaciones inadecuadas",
          },
          {
            heading:
              "Valores de Referencia para Hombres y Mujeres (Adultos 18-65 años)",
            table: [
              [
                "Nivel",
                "Hombres (reps completos)",
                "Mujeres (reps con rodillas)",
              ],
              ["Excelente", "40+", "30+"],
              ["Bueno", "25-39", "15-29"],
              ["Promedio", "15-24", "10-14"],
              ["Deficiente", "5-14", "5-9"],
              ["Muy bajo", "<5", "<5"],
            ],
          },
        ],
      },
    },
    {
      id: "lowerBodyStrength",
      text: "Evaluación de la Fuerza en Miembros Inferiores: Test de Sentadilla a Repeticiones",
      image: image_g,
      options: ["Excelente", "Bueno", "Promedio", "Deficiente", "Muy bajo"],
      hasObservations: true,
      modalContent: {
        title:
          "Evaluación de la Fuerza en Miembros Inferiores: Test de Sentadilla a Repeticiones",
        sections: [
          {
            heading: "Objetivo",
            text: "Medir la resistencia y fuerza funcional de los músculos de las piernas (cuádriceps, isquiotibiales y glúteos) mediante una prueba sencilla y validada.",
          },
          {
            heading: "Procedimiento",
            subsections: [
              {
                heading: "Posición inicial",
                text: "De pie, pies al ancho de los hombros, brazos cruzados sobre el pecho.",
              },
              {
                heading: "Ejecución",
                text: "Realizar la máxima cantidad de sentadillas completas (90° de flexión de rodilla) en 60 segundos, manteniendo buena técnica y sin pausas prolongadas.",
              },
            ],
          },
          {
            heading: "Valores de Referencia (Repeticiones en 60s)",
            table: [
              ["Nivel", "Hombres", "Mujeres"],
              ["Excelente", "50+", "45+"],
              ["Bueno", "40-49", "35-44"],
              ["Promedio", "30-39", "25-34"],
              ["Deficiente", "20-29", "15-24"],
              ["Muy bajo", "<20", "<15"],
            ],
          },
        ],
      },
    },
    {
      id: "cardio",
      text: "Evaluación Cardiorrespiratoria: Test del Escalón de 3 Minutos",
      image: image_h,
      options: ["Excelente", "Bueno", "Promedio", "Deficiente", "Muy bajo"],
      hasObservations: true,
      modalContent: {
        title: "Evaluación Cardiorrespiratoria: Test del Escalón de 3 Minutos",
        sections: [
          {
            heading: "Descripción",
            text: "Es una prueba submáxima que evalúa la capacidad aeróbica y la recuperación cardiovascular midiendo la frecuencia cardíaca tras un esfuerzo controlado.",
          },
          {
            heading: "Procedimiento",
            subsections: [
              {
                heading: "Configuración",
                text: "Altura del escalón: 30cm (según protocolo).\nRitmo: 24 pasos/min (hombres) y 22 pasos/min (mujeres)\nDuración: 3 minutos continuos subiendo y bajando el escalón con un patrón constante (pie derecho arriba, pie izquierdo arriba, pie derecho abajo, pie izquierdo abajo).",
              },
              {
                heading: "Medición",
                text: "Al finalizar, la frecuencia cardíaca se toma durante 60 segundos (entre 5-15 seg postejercicio).",
              },
            ],
          },
          {
            heading: "Valores de Referencia (Frecuencia Cardíaca en ppm)",
            table: [
              ["Nivel", "Hombres", "Mujeres"],
              ["Excelente", "<84", "<88"],
              ["Bueno", "85-98", "89-100"],
              ["Promedio", "99-111", "101-118"],
              ["Deficiente", "112-128", "119-129"],
              ["Muy bajo", ">128", ">129"],
            ],
          },
          {
            heading: "Consideraciones",
            text: "Evitar la prueba en personas con problemas cardiovasculares sin evaluación médica previa.\nComo toma los datos el entrenador en un desplegable donde pueda elegir estos 5 parámetros:\n- Excelente\n- Bueno\n- Promedio\n- Deficiente\n- Muy bajo\nOBSERVACIONES",
          },
          {
            heading: "Como tomar los pliegues con plicómetro",
            subsections: [
              {
                heading: "Descripción",
                text: "La medición de estos 5 pliegues cutáneos con plicómetro en las zonas (tricipital, subescapular, abdominal, supra espinal y muslo) siguiendo protocolo de Jackson & Pollock o ISAK. Con el objetivo de determinar el porcentaje graso, masa magra, quilos de grasa y índice de masa magra del cliente",
              },
              {
                heading: "Ubicación precisa para la toma de los pliegues",
                text: "Tricipital: En la cara posterior del brazo, en la línea media entre el acromion y el olécranon, pliegue vertical.\nSubescapular: 1-2 cm debajo del ángulo inferior de la escápula, pliegue diagonal hacia abajo y lateral.\nAbdominal: 2 cm lateral al ombligo, pliegue vertical.\nSupra espinal: En la intersección entre la cresta ilíaca y la línea axilar anterior, pliegue diagonal en dirección a la ingle.\nMuslo: En la parte anterior del muslo, en la línea media entre la ingle y la rótula, pliegue vertical.",
              },
              {
                heading: "Recomendaciones científicas de medición",
                text: "Medir siempre del lado derecho del cuerpo.\nRealizar mínimo dos mediciones por pliegue y promediar.\nMantener presión constante del calibrador (≈2 seg).\nEstandarizar la posición del sujeto: relajado y de pie.",
              },
            ],
          },
          {
            heading: "Como tomar las medidas perimetrales",
            subsections: [
              {
                heading: "Descripción",
                text: "Las medidas se toman con una cinta métrica flexible y no elástica, siguiendo protocolos como ISAK para evaluar la composición corporal y estimar el % de grasa.",
              },
              {
                heading: "Ubicación y técnica de medición",
                text: "Cuello: En la parte más estrecha, justo debajo de la laringe, con la cabeza en posición neutral.\nBrazo: En el punto medio entre el acromion (hombro) y el olécranon (codo), con el brazo relajado y colgando a los lados.\nCintura: En el punto más estrecho del abdomen o 2 cm por encima del ombligo (según protocolo), con la persona de pie y relajada.\nCadera: En la zona más prominente de los glúteos, manteniendo la cinta horizontal.\nMuslo: En la parte media entre la ingle rotula unos 2 cm por debajo del gluteo, con la pierna relajada y ligeramente separada.",
              },
              {
                heading: "Recomendaciones científicas",
                text: "Medir siempre del lado derecho del cuerpo.\nMantener la cinta ajustada sin comprimir los tejidos.\nTomar mínimo dos mediciones y promediar.\nRealizar las mediciones en un ambiente controlado y a la misma hora del día si es posible. Estas mediciones, combinadas con pliegues, permiten estimar el % de grasa corporal de forma precisa.",
              },
            ],
          },
        ],
      },
    },
  ]; */

  const questions = [
    {
      id: "ankleDorsiflexion",
      text: t("anthropometric.valoration.ankleDorsiflexion.text"),
      image: image_a,
      options: [
        t("anthropometric.valoration.ankleDorsiflexion.options.normal"),
        t("anthropometric.valoration.ankleDorsiflexion.options.limited"),
        t(
          "anthropometric.valoration.ankleDorsiflexion.options.severelyReduced"
        ),
      ],
      hasObservations: true,
      modalContent: {
        title: t("anthropometric.valoration.ankleDorsiflexion.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.ankleDorsiflexion.modal.sections.testDescription.heading"
            ),
            subsections: [
              {
                heading: t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.testDescription.subsections.initialPosition.heading"
                ),
                text: t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.testDescription.subsections.initialPosition.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.testDescription.subsections.execution.heading"
                ),
                text: t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.testDescription.subsections.execution.text"
                ),
              },
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.ankleDorsiflexion.modal.sections.resultEvaluation.heading"
            ),
            text: t(
              "anthropometric.valoration.ankleDorsiflexion.modal.sections.resultEvaluation.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.ankleDorsiflexion.modal.sections.dorsiflexionRanges.heading"
            ),
            table: [
              [
                t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.dorsiflexionRanges.table.normal.label"
                ),
                t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.dorsiflexionRanges.table.normal.value"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.dorsiflexionRanges.table.limited.label"
                ),
                t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.dorsiflexionRanges.table.limited.value"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.dorsiflexionRanges.table.severelyReduced.label"
                ),
                t(
                  "anthropometric.valoration.ankleDorsiflexion.modal.sections.dorsiflexionRanges.table.severelyReduced.value"
                ),
              ],
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.ankleDorsiflexion.modal.sections.recommendedProtocol.heading"
            ),
            text: t(
              "anthropometric.valoration.ankleDorsiflexion.modal.sections.recommendedProtocol.text"
            ),
          },
        ],
      },
    },
    {
      id: "singleLegSquat",
      text: t("anthropometric.valoration.singleLegSquat.text"),
      image: image_b,
      options: [
        t("anthropometric.valoration.singleLegSquat.options.good"),
        t("anthropometric.valoration.singleLegSquat.options.fair"),
        t("anthropometric.valoration.singleLegSquat.options.unable"),
      ],
      fieldGroups: [
        {
          label: t(
            "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.label"
          ),
          key: "",
          fields: [
            {
              name: "kneeAlignment",
              label: t(
                "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.fields.kneeAlignment"
              ),
            },
            {
              name: "pelvicStability",
              label: t(
                "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.fields.pelvicStability"
              ),
            },
            {
              name: "ankleMobility",
              label: t(
                "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.fields.ankleMobility"
              ),
            },
            {
              name: "squatDepth",
              label: t(
                "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.fields.squatDepth"
              ),
            },
            {
              name: "posturalControl",
              label: t(
                "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.fields.posturalControl"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.options.good"
            ),
            t(
              "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.options.fair"
            ),
            t(
              "anthropometric.valoration.singleLegSquat.fieldGroups.criteria.options.unable"
            ),
          ],
        },
      ],
      modalContent: {
        title: t("anthropometric.valoration.singleLegSquat.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.description.heading"
            ),
            text: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.description.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.procedure.heading"
            ),
            subsections: [
              {
                heading: t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.procedure.subsections.initialPosition.heading"
                ),
                text: t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.procedure.subsections.initialPosition.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.procedure.subsections.execution.heading"
                ),
                text: t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.procedure.subsections.execution.text"
                ),
              },
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.evaluation.heading"
            ),
            text: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.evaluation.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.heading"
            ),
            text: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.text"
            ),
            table: [
              [
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.header.criterion"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.header.good"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.header.fair"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.header.unable"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.kneeAlignment.label"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.kneeAlignment.good"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.kneeAlignment.fair"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.kneeAlignment.unable"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.pelvicStability.label"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.pelvicStability.good"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.pelvicStability.fair"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.pelvicStability.unable"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.ankleMobility.label"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.ankleMobility.good"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.ankleMobility.fair"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.ankleMobility.unable"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.squatDepth.label"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.squatDepth.good"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.squatDepth.fair"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.squatDepth.unable"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.posturalControl.label"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.posturalControl.good"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.posturalControl.fair"
                ),
                t(
                  "anthropometric.valoration.singleLegSquat.modal.sections.evaluationCriteria.table.posturalControl.unable"
                ),
              ],
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.recommendations.heading"
            ),
            text: t(
              "anthropometric.valoration.singleLegSquat.modal.sections.recommendations.text"
            ),
          },
        ],
      },
    },
    {
      id: "staticPosture",
      text: t("anthropometric.valoration.staticPosture.text"),
      image: image_c,
      image_2: image_c_2,
      options: [
        t("anthropometric.valoration.staticPosture.options.good"),
        t("anthropometric.valoration.staticPosture.options.fair"),
        t("anthropometric.valoration.staticPosture.options.unable"),
      ],
      fieldGroups: [
        {
          label: t(
            "anthropometric.valoration.staticPosture.fieldGroups.sagittal.label"
          ),
          key: "sagittal",
          fields: [
            {
              name: "bodyAxis",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.sagittal.fields.bodyAxis"
              ),
            },
            {
              name: "spinalCurvature",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.sagittal.fields.spinalCurvature"
              ),
            },
            {
              name: "headPosition",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.sagittal.fields.headPosition"
              ),
            },
            {
              name: "pelvicTilt",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.sagittal.fields.pelvicTilt"
              ),
            },
            {
              name: "kneeFlexion",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.sagittal.fields.kneeFlexion"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.sagittal.options.good"
            ),
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.sagittal.options.fair"
            ),
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.sagittal.options.unable"
            ),
          ],
        },
        {
          label: t(
            "anthropometric.valoration.staticPosture.fieldGroups.frontal.label"
          ),
          key: "frontal",
          fields: [
            {
              name: "shoulderSymmetry",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.frontal.fields.shoulderSymmetry"
              ),
            },
            {
              name: "spinalAlignment",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.frontal.fields.spinalAlignment"
              ),
            },
            {
              name: "pelvicLevel",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.frontal.fields.pelvicLevel"
              ),
            },
            {
              name: "kneeValgusVarus",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.frontal.fields.kneeValgusVarus"
              ),
            },
            {
              name: "footArch",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.frontal.fields.footArch"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.frontal.options.good"
            ),
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.frontal.options.fair"
            ),
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.frontal.options.unable"
            ),
          ],
        },
        {
          label: t(
            "anthropometric.valoration.staticPosture.fieldGroups.transversal.label"
          ),
          key: "transversal",
          fields: [
            {
              name: "headRotation",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.transversal.fields.headRotation"
              ),
            },
            {
              name: "scapularRotation",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.transversal.fields.scapularRotation"
              ),
            },
            {
              name: "pelvicTorsion",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.transversal.fields.pelvicTorsion"
              ),
            },
            {
              name: "kneeFootOrientation",
              label: t(
                "anthropometric.valoration.staticPosture.fieldGroups.transversal.fields.kneeFootOrientation"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.transversal.options.good"
            ),
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.transversal.options.fair"
            ),
            t(
              "anthropometric.valoration.staticPosture.fieldGroups.transversal.options.unable"
            ),
          ],
        },
      ],
      modalContent: {
        title: t("anthropometric.valoration.staticPosture.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.staticPosture.modal.sections.description.heading"
            ),
            text: t(
              "anthropometric.valoration.staticPosture.modal.sections.description.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.staticPosture.modal.sections.associatedSyndromes.heading"
            ),
            subsections: [
              {
                heading: t(
                  "anthropometric.valoration.staticPosture.modal.sections.associatedSyndromes.subsections.upperCrossedSyndrome.heading"
                ),
                text: t(
                  "anthropometric.valoration.staticPosture.modal.sections.associatedSyndromes.subsections.upperCrossedSyndrome.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.staticPosture.modal.sections.associatedSyndromes.subsections.lowerCrossedSyndrome.heading"
                ),
                text: t(
                  "anthropometric.valoration.staticPosture.modal.sections.associatedSyndromes.subsections.lowerCrossedSyndrome.text"
                ),
              },
            ],
          },
        ],
      },
    },
    {
      id: "overheadSquat",
      text: t("anthropometric.valoration.overheadSquat.text"),
      image: image_d,
      options: [
        t("anthropometric.valoration.overheadSquat.options.good"),
        t("anthropometric.valoration.overheadSquat.options.fair"),
        t("anthropometric.valoration.overheadSquat.options.unable"),
      ],
      fieldGroups: [
        {
          label: t(
            "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.label"
          ),
          key: "sagittal",
          fields: [
            {
              name: "trunkControl",
              label: t(
                "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.fields.trunkControl"
              ),
            },
            {
              name: "ankleMobility",
              label: t(
                "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.fields.ankleMobility"
              ),
            },
            {
              name: "hipMobility",
              label: t(
                "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.fields.hipMobility"
              ),
            },
            {
              name: "spinalMobility",
              label: t(
                "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.fields.spinalMobility"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.options.good"
            ),
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.options.fair"
            ),
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.sagittal.options.unable"
            ),
          ],
        },
        {
          label: t(
            "anthropometric.valoration.overheadSquat.fieldGroups.frontal.label"
          ),
          key: "frontal",
          fields: [
            {
              name: "kneeAlignment",
              label: t(
                "anthropometric.valoration.overheadSquat.fieldGroups.frontal.fields.kneeAlignment"
              ),
            },
            {
              name: "footAlignment",
              label: t(
                "anthropometric.valoration.overheadSquat.fieldGroups.frontal.fields.footAlignment"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.frontal.options.good"
            ),
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.frontal.options.fair"
            ),
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.frontal.options.unable"
            ),
          ],
        },
        {
          label: t(
            "anthropometric.valoration.overheadSquat.fieldGroups.transversal.label"
          ),
          key: "transversal",
          fields: [
            {
              name: "compensatoryRotations",
              label: t(
                "anthropometric.valoration.overheadSquat.fieldGroups.transversal.fields.compensatoryRotations"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.transversal.options.good"
            ),
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.transversal.options.fair"
            ),
            t(
              "anthropometric.valoration.overheadSquat.fieldGroups.transversal.options.unable"
            ),
          ],
        },
      ],
      modalContent: {
        title: t("anthropometric.valoration.overheadSquat.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.overheadSquat.modal.sections.description.heading"
            ),
            text: t(
              "anthropometric.valoration.overheadSquat.modal.sections.description.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.overheadSquat.modal.sections.evaluatedAspects.heading"
            ),
            text: t(
              "anthropometric.valoration.overheadSquat.modal.sections.evaluatedAspects.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.overheadSquat.modal.sections.detectedDysfunctions.heading"
            ),
            text: t(
              "anthropometric.valoration.overheadSquat.modal.sections.detectedDysfunctions.text"
            ),
          },
        ],
      },
    },
    {
      id: "hipMobility",
      text: t("anthropometric.valoration.hipMobility.text"),
      image: image_e,
      options: [
        t("anthropometric.valoration.hipMobility.options.good"),
        t("anthropometric.valoration.hipMobility.options.fair"),
        t("anthropometric.valoration.hipMobility.options.deficient"),
      ],
      fieldGroups: [
        {
          label: t(
            "anthropometric.valoration.hipMobility.fieldGroups.criteria.label"
          ),
          key: "",
          fields: [
            {
              name: "controlMotor",
              label: t(
                "anthropometric.valoration.hipMobility.fieldGroups.criteria.fields.controlMotor"
              ),
            },
            {
              name: "hipHingePattern",
              label: t(
                "anthropometric.valoration.hipMobility.fieldGroups.criteria.fields.hipHingePattern"
              ),
            },
            {
              name: "stabilityMobility",
              label: t(
                "anthropometric.valoration.hipMobility.fieldGroups.criteria.fields.stabilityMobility"
              ),
            },
          ],
          options: [
            t(
              "anthropometric.valoration.hipMobility.fieldGroups.criteria.options.good"
            ),
            t(
              "anthropometric.valoration.hipMobility.fieldGroups.criteria.options.fair"
            ),
            t(
              "anthropometric.valoration.hipMobility.fieldGroups.criteria.options.deficient"
            ),
          ],
        },
      ],
      modalContent: {
        title: t("anthropometric.valoration.hipMobility.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.hipMobility.modal.sections.description.heading"
            ),
            text: t(
              "anthropometric.valoration.hipMobility.modal.sections.description.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.hipMobility.modal.sections.evaluatedAspects.heading"
            ),
            text: t(
              "anthropometric.valoration.hipMobility.modal.sections.evaluatedAspects.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.hipMobility.modal.sections.recommendations.heading"
            ),
            text: t(
              "anthropometric.valoration.hipMobility.modal.sections.recommendations.text"
            ),
          },
        ],
      },
    },
    {
      id: "upperBodyStrength",
      text: t("anthropometric.valoration.upperBodyStrength.text"),
      image: image_f,
      options: [
        t("anthropometric.valoration.upperBodyStrength.options.excellent"),
        t("anthropometric.valoration.upperBodyStrength.options.good"),
        t("anthropometric.valoration.upperBodyStrength.options.average"),
        t("anthropometric.valoration.upperBodyStrength.options.deficient"),
        t("anthropometric.valoration.upperBodyStrength.options.veryLow"),
      ],
      hasObservations: true,
      modalContent: {
        title: t("anthropometric.valoration.upperBodyStrength.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.upperBodyStrength.modal.sections.description.heading"
            ),
            text: t(
              "anthropometric.valoration.upperBodyStrength.modal.sections.description.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.upperBodyStrength.modal.sections.objective.heading"
            ),
            text: t(
              "anthropometric.valoration.upperBodyStrength.modal.sections.objective.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.upperBodyStrength.modal.sections.evaluatedAspects.heading"
            ),
            text: t(
              "anthropometric.valoration.upperBodyStrength.modal.sections.evaluatedAspects.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.heading"
            ),
            table: [
              [
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.header.level"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.header.men"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.header.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.excellent.label"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.excellent.men"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.excellent.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.good.label"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.good.men"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.good.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.average.label"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.average.men"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.average.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.deficient.label"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.deficient.men"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.deficient.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.veryLow.label"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.veryLow.men"
                ),
                t(
                  "anthropometric.valoration.upperBodyStrength.modal.sections.referenceValues.table.veryLow.women"
                ),
              ],
            ],
          },
        ],
      },
    },
    {
      id: "lowerBodyStrength",
      text: t("anthropometric.valoration.lowerBodyStrength.text"),
      image: image_g,
      options: [
        t("anthropometric.valoration.lowerBodyStrength.options.excellent"),
        t("anthropometric.valoration.lowerBodyStrength.options.good"),
        t("anthropometric.valoration.lowerBodyStrength.options.average"),
        t("anthropometric.valoration.lowerBodyStrength.options.deficient"),
        t("anthropometric.valoration.lowerBodyStrength.options.veryLow"),
      ],
      hasObservations: true,
      modalContent: {
        title: t("anthropometric.valoration.lowerBodyStrength.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.lowerBodyStrength.modal.sections.objective.heading"
            ),
            text: t(
              "anthropometric.valoration.lowerBodyStrength.modal.sections.objective.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.lowerBodyStrength.modal.sections.procedure.heading"
            ),
            subsections: [
              {
                heading: t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.procedure.subsections.initialPosition.heading"
                ),
                text: t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.procedure.subsections.initialPosition.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.procedure.subsections.execution.heading"
                ),
                text: t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.procedure.subsections.execution.text"
                ),
              },
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.heading"
            ),
            table: [
              [
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.header.level"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.header.men"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.header.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.excellent.label"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.excellent.men"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.excellent.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.good.label"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.good.men"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.good.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.average.label"
                ),
                t(
                  "anthropometric.v aloration.lowerBodyStrength.modal.sections.referenceValues.table.average.men"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.average.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.deficient.label"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.deficient.men"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.deficient.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.veryLow.label"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.veryLow.men"
                ),
                t(
                  "anthropometric.valoration.lowerBodyStrength.modal.sections.referenceValues.table.veryLow.women"
                ),
              ],
            ],
          },
        ],
      },
    },
    {
      id: "cardio",
      text: t("anthropometric.valoration.cardio.text"),
      image: image_h,
      options: [
        t("anthropometric.valoration.cardio.options.excellent"),
        t("anthropometric.valoration.cardio.options.good"),
        t("anthropometric.valoration.cardio.options.average"),
        t("anthropometric.valoration.cardio.options.deficient"),
        t("anthropometric.valoration.cardio.options.veryLow"),
      ],
      hasObservations: true,
      modalContent: {
        title: t("anthropometric.valoration.cardio.modal.title"),
        sections: [
          {
            heading: t(
              "anthropometric.valoration.cardio.modal.sections.description.heading"
            ),
            text: t(
              "anthropometric.valoration.cardio.modal.sections.description.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.cardio.modal.sections.procedure.heading"
            ),
            subsections: [
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.procedure.subsections.configuration.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.procedure.subsections.configuration.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.procedure.subsections.measurement.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.procedure.subsections.measurement.text"
                ),
              },
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.cardio.modal.sections.referenceValues.heading"
            ),
            table: [
              [
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.header.level"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.header.men"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.header.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.excellent.label"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.excellent.men"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.excellent.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.good.label"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.good.men"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.good.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.average.label"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.average.men"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.average.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.deficient.label"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.deficient.men"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.deficient.women"
                ),
              ],
              [
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.veryLow.label"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.veryLow.men"
                ),
                t(
                  "anthropometric.valoration.cardio.modal.sections.referenceValues.table.veryLow.women"
                ),
              ],
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.cardio.modal.sections.considerations.heading"
            ),
            text: t(
              "anthropometric.valoration.cardio.modal.sections.considerations.text"
            ),
          },
          {
            heading: t(
              "anthropometric.valoration.cardio.modal.sections.skinfoldMeasurement.heading"
            ),
            subsections: [
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.skinfoldMeasurement.subsections.description.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.skinfoldMeasurement.subsections.description.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.skinfoldMeasurement.subsections.location.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.skinfoldMeasurement.subsections.location.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.skinfoldMeasurement.subsections.recommendations.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.skinfoldMeasurement.subsections.recommendations.text"
                ),
              },
            ],
          },
          {
            heading: t(
              "anthropometric.valoration.cardio.modal.sections.circumferenceMeasurement.heading"
            ),
            subsections: [
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.circumferenceMeasurement.subsections.description.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.circumferenceMeasurement.subsections.description.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.circumferenceMeasurement.subsections.location.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.circumferenceMeasurement.subsections.location.text"
                ),
              },
              {
                heading: t(
                  "anthropometric.valoration.cardio.modal.sections.circumferenceMeasurement.subsections.recommendations.heading"
                ),
                text: t(
                  "anthropometric.valoration.cardio.modal.sections.circumferenceMeasurement.subsections.recommendations.text"
                ),
              },
            ],
          },
        ],
      },
    },
  ];

  return (
    <form onSubmit={formik.handleSubmit} className="">
      <style>
        {`
      details > summary .arrow {
        display: inline-block;
        transition: transform 0.3s ease;
      }
      details:not([open]) > summary .arrow {
        transform: rotate(-90deg); /* Right when closed */
      }
      details[open] > summary .arrow {
        transform: rotate(0deg); /* Down when open */
      }
    `}
      </style>
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          {t("anthropometric.valoration.title")}
        </h2>
        <div className="space-y-6">
          {questions.map((q) => (
            <details key={q.id} className="p-4">
              <summary className="flex items-center gap-2 cursor-pointer">
                <span className="arrow">▼</span>
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-medium text-gray-700">
                    {q.text}
                  </h3>
                  {
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        getTable({ id: q.id });
                        setShowHistory(true);
                      }}
                      className="text-primary-500 cursor-pointer"
                    >
                      ({t("anthropometric.valoration.history")})
                    </span>
                  }
                  {q.modalContent && (
                    <button
                      type="button"
                      className="text-blue-600 hover:text-blue-800 transition"
                      onClick={(e) => {
                        e.preventDefault();
                        setModalContent({ ...q.modalContent, image: q.image });
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="h-4 w-4 text-primary"
                      />
                    </button>
                  )}
                  {q.options.length > 0 && (
                    <select
                      name={q.id}
                      value={formik.values[q.id]}
                      onChange={formik.handleChange}
                      className="p-1 border rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none text-base w-auto min-w-[120px]"
                    >
                      <option value="">
                        {t("anthropometric.valoration.select")}
                      </option>
                      {q.options.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              </summary>
              <div className="mt-4">
                {q.inputType === "text" && (
                  <input
                    type="text"
                    name={q.id}
                    value={formik.values[q.id]}
                    onChange={formik.handleChange}
                    className="w-full sm:w-1/2 p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none text-base"
                    placeholder="Nombre y teléfono"
                  />
                )}
                {q.inputType === "number" && (
                  <input
                    type="number"
                    name={q.id}
                    value={formik.values[q.id]}
                    onChange={formik.handleChange}
                    className="w-full sm:w-1/4 p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none text-base"
                    placeholder="Pulsaciones"
                    min="0"
                  />
                )}
                {q.fieldGroups && (
                  <div className="space-y-3 ml-4 mt-4">
                    {q.fieldGroups.map((group) => (
                      <div key={group.label} className="p-2">
                        <h4 className="text-base font-semibold text-gray-700">
                          {group.label}
                        </h4>
                        <div className="space-y-3 mt-2">
                          {group.fields.map((field) => (
                            <div
                              key={field.name}
                              className="flex items-center gap-2"
                            >
                              <span className="text-base text-gray-600 w-[300px] flex-shrink-0">
                                {field.label}
                              </span>
                              <div className="flex gap-4">
                                {group.options.map((opt) => (
                                  <label
                                    key={opt}
                                    className="flex items-center gap-1"
                                  >
                                    <input
                                      type="radio"
                                      name={`${q.id}Fields.${group.key ? group.key : ""}${group.key ? "." : ""}${field.name}`}
                                      value={opt}
                                      color="primary"
                                      checked={
                                        group.key
                                          ? formik.values[`${q.id}Fields`][
                                              group.key
                                            ][field.name] === opt
                                          : formik.values[`${q.id}Fields`][
                                              field.name
                                            ] === opt
                                      }
                                      onChange={formik.handleChange}
                                      className="w-4 h-4 text-primary-500 bg-gray-100 border-gray-300 focus:ring-primary-500 dark:focus:ring-primary-500 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                    />
                                    <span className="text-base text-gray-700">
                                      {opt}
                                    </span>
                                  </label>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {q.hasObservations && (
                  <div className="mt-4">
                    <h4 className="text-base font-semibold text-gray-900 mb-2">
                      {t("anthropometric.valoration.observations")}
                    </h4>
                    <textarea
                      name={`${q.id}Observations`}
                      value={formik.values[`${q.id}Observations`]}
                      onChange={formik.handleChange}
                      className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none text-base"
                      rows={4}
                      placeholder={t(
                        "anthropometric.valoration.observations_placeholder"
                      )}
                    />
                  </div>
                )}
              </div>
            </details>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {showHistory && (
          <motion.div
            className="fixed inset-0 flex justify-end z-50 bg-black bg-opacity-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.2 } }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setShowHistory(false);
            }}
          >
            <motion.div
              className="w-[800px] bg-white p-8 shadow-2xl overflow-y-auto border-l border-gray-300"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{
                x: "100%",
                transition: { type: "tween", ease: "easeInOut", duration: 0.3 },
              }}
              transition={{ type: "tween", ease: "easeOut", duration: 0.3 }}
            >
              <ValorationStateEalthHistory
                data={historyData}
                isLoading={isLoadingHistory}
                title={t("user.views.history")}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {modalContent && (
          <motion.div
            className="fixed inset-0 flex justify-end z-50 bg-black bg-opacity-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.2 } }}
            onClick={(e) => {
              if (e.target === e.currentTarget) setModalContent(null);
            }}
          >
            <motion.div
              className="w-[800px] bg-white p-8 shadow-2xl overflow-y-auto border-l border-gray-300"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{
                x: "100%",
                transition: { type: "tween", ease: "easeInOut", duration: 0.3 },
              }}
              transition={{ type: "tween", ease: "easeOut", duration: 0.3 }}
            >
              <div className="flex justify-between items-center mb-6 border-b pb-4">
                <h3 className="text-2xl font-bold text-gray-900">
                  {modalContent.title}
                </h3>
                <button
                  type="button"
                  className="text-gray-500 hover:text-gray-800 transition"
                  onClick={() => setModalContent(null)}
                >
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="space-y-6 text-gray-700">
                {modalContent.sections.map((section, idx) => (
                  <div key={idx} className="border-b pb-6 last:border-b-0">
                    <h4 className="text-xl font-semibold text-gray-900 mb-3 border-l-4 border-primary pl-3">
                      {section.heading}
                    </h4>
                    {section.text && (
                      <div className="space-y-2 pl-3">
                        {section.text.split("\n").map((line, i) => (
                          <span
                            key={i}
                            className={
                              line.startsWith("- ") ||
                              line.startsWith("Nota: ") ||
                              line.startsWith("Músculos ")
                                ? "block pl-4 text-gray-800"
                                : "block"
                            }
                          >
                            {line.startsWith("- ")
                              ? `• ${line.slice(2)}`
                              : line}
                          </span>
                        ))}
                      </div>
                    )}
                    {section.subsections && (
                      <div className="space-y-3 pl-3">
                        {section.subsections.map((subsection, subIdx) => (
                          <div key={subIdx} className="p-2">
                            <h5 className="text-base font-semibold text-gray-700">
                              {subsection.heading}
                            </h5>
                            <div className="mt-2 pl-2 text-gray-700">
                              {subsection.text.split("\n").map((line, i) => (
                                <span
                                  key={i}
                                  className={
                                    line.startsWith("- ") ||
                                    line.startsWith("Nota: ") ||
                                    line.startsWith("Músculos ")
                                      ? "block pl-4 text-gray-800"
                                      : "block"
                                  }
                                >
                                  {line.startsWith("- ")
                                    ? `• ${line.slice(2)}`
                                    : line}
                                </span>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {section.table && (
                      <div className="overflow-x-auto mt-4">
                        <table className="w-full border border-gray-300 rounded-md overflow-hidden shadow-md">
                          <thead className="bg-gray-100 text-gray-900 uppercase text-sm">
                            <tr>
                              {section.table[0].map((header, i) => (
                                <th
                                  key={i}
                                  className="p-3 text-left font-semibold border-b border-gray-300"
                                >
                                  {header}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200">
                            {section.table.slice(1).map((row, rowIdx) => (
                              <tr key={rowIdx} className="hover:bg-gray-50">
                                {row.map((cell, cellIdx) => (
                                  <td
                                    key={cellIdx}
                                    className="p-3 border-b border-gray-300"
                                  >
                                    {cell}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ))}
                <img
                  src={modalContent?.image}
                  alt="Modal Image"
                  className="w-full h-auto rounded-lg shadow-md"
                />
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </form>
  );
};

export default ValorationStateEalth;
